import { StatusColors } from '@models/enums';
import { ProcessEnvMap } from '@models/interfaces';

export const color: ProcessEnvMap = {
  Primary: StatusColors.Primary,
  Secondary: StatusColors.Gray,
};
